// src/utils/mapChemicalToProductCode.js

// Sinónimos por producto. El catálogo da los códigos válidos, pero no los
// sinónimos: que "dióxido de carbono" signifique CO2 es conocimiento de idioma.
//
// LHY (hidrógeno líquido) y N/A no tienen sinónimos a propósito: está pendiente
// confirmar con operaciones cómo se distingue LHY de H2 en los XML de Lyta.
// Hasta entonces, todo hidrógeno sigue mapeando a H2.
export const MAPEO_SINONIMOS = [
  { codes: ['CO2'], keywords: ['dióxido de carbono', 'dioxido de carbono', 'co2'] },
  { codes: ['LIN'], keywords: ['nitrógeno', 'nitrogeno', 'nitro', 'lin', 'n2'] },
  { codes: ['LOX'], keywords: ['oxígeno', 'oxigeno', 'lox', 'oxig', 'o2'] },
  { codes: ['LAR'], keywords: ['argón', 'argon', 'lar', 'arg'] },
  { codes: ['H2'], keywords: ['hidrógeno', 'hidrogeno', 'h2'] },
];

export const PRODUCTOS_CON_SINONIMOS = MAPEO_SINONIMOS.map(({ codes }) => codes[0]);

/**
 * Devuelve los productos del catálogo que el mapa no sabe reconocer por texto.
 *
 * @param {Array<Object>} catalogo Respuesta de ConceptoGasto/Consultar.
 * @returns {Array<String>}
 */
export const productosSinSinonimos = (catalogo) => {
  if (!Array.isArray(catalogo)) return [];
  const conocidos = new Set(PRODUCTOS_CON_SINONIMOS);
  const productos = new Set(
    catalogo.map((concepto) => concepto?.Producto).filter(Boolean)
  );
  return [...productos].filter((producto) => !conocidos.has(producto));
};

/**
 * Maps a natural chemical substance name (often found in XML invoices)
 * to its corresponding internal API product code (e.g., CO2, LIN, LOX, LAR, H2).
 *
 * @param {string} searchTerm - The descriptive name of the substance.
 * @returns {string} The mapped product code or a cleaned version of the original term.
 */
export const mapChemicalToProductCode = (searchTerm) => {
  if (!searchTerm) return '';

  const cleanTerm = searchTerm.toLowerCase();

  // Keywords cortas (≤3 chars) se evalúan con word-boundary para evitar
  // falsos positivos por substring (ej: 'lin' dentro de 'cilindro').
  const matchesKeyword = (term, keyword) => {
    if (keyword.length <= 3) {
      return new RegExp(`\\b${keyword}\\b`).test(term);
    }
    return term.includes(keyword);
  };

  for (const mapping of MAPEO_SINONIMOS) {
    if (mapping.keywords.some(keyword => matchesKeyword(cleanTerm, keyword))) {
      return mapping.codes[0];
    }
  }

  // Return empty string if no mapping found to avoid filtering out all options in Autocomplete
  return '';
};
